export default {
  title: 'Udskrevet kvittering',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Skjul servicegebyr på kvittering',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Skjul prissektion på kvittering',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Skjul navne på tilvalgsgrupper på kvittering',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
